// extracted by mini-css-extract-plugin
export default {"statutory-component":"EditCompany_statutory-component__hAEO4","modal-header":"EditCompany_modal-header__j4lho","modal-header-filter":"EditCompany_modal-header-filter__zEzBY"};